import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const BackendDevelopment = () => {
  useEffect(() => {
    // Scroll-based navigation highlighting
    const sections = document.querySelectorAll(".tab-data[id]");
    const navLinks = document.querySelectorAll(".nav-selector a");

    const navHighlighter = () => {
      let scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop =
          current.getBoundingClientRect().top + window.pageYOffset - 50;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          navLinks.forEach((link) => {
            link.parentElement.classList.remove("active");
            if (link.getAttribute("href") === `#${sectionId}`) {
              link.parentElement.classList.add("active");
            }
          });
        }
      });
    };

    window.addEventListener("scroll", navHighlighter);
    return () => window.removeEventListener("scroll", navHighlighter);
  }, []);

  return (
    <div className="backend-development-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.3s">
              Backend Development
            </h1>
          </div>
        </div>
      </section>

      <section className="top-services-section">
        <div className="container">
          <div className="title">
            <h2 className="wow fadeInUp">
              The<span className="gradient-text"> Hidden Hero</span> :<br />
              How Backend Drives App Success
            </h2>
            <h3 className="wow fadeInUp">How we work</h3>
            <p className="wow fadeInUp">
              At Slash Star, we take a comprehensive approach to backend
              development services. Our team of experienced developers works
              closely with our clients to create scalable, efficient, and
              reliable web applications that meet their unique needs. We
              prioritize security throughout the development process, building
              multiple layers of protection into every application we create.
              From planning and strategy to ongoing support, we're committed to
              delivering high-quality backend development solutions that drive
              your business forward.
            </p>
          </div>
          <div className="row flex-start wow fadeInUp">
            <div className="col col-4">
              <div className="box">
                <span>01</span>
                <h3>Project ideation</h3>
                <p>
                  We start by listening to your business goals, challenges, and
                  vision for your web application. We learn about your target
                  audience, competitors, and key features you require to create
                  an optimal solution.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>02</span>
                <h3>Planning</h3>
                <p>
                  Based on our initial discussion, we create a detailed project
                  plan that includes timelines, milestones, and deliverables. We
                  collaborate with you to finalize the scope and ensure we're
                  aligned on the project's objectives.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>03</span>
                <h3>Development</h3>
                <p>
                  Once we have a clear understanding of your requirements, we
                  move on to create high fidelity designs. We work
                  collaboratively with you to ensure that the design aligns with
                  your brand and user experience goals.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>04</span>
                <h3>Testing</h3>
                <p>
                  We follow an agile development approach, which means we work
                  in sprints to deliver functional pieces of the project, test
                  them, and make adjustments as needed. This allows us to be
                  flexible to changing requirements that emerge throughout the
                  development process.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>05</span>
                <h3>Deployment</h3>
                <p>
                  Before we deploy your web application, we thoroughly test it
                  for functionality, usability, security, and performance. We
                  make sure that everything is working as expected, and we
                  conduct user acceptance testing to ensure that the solution
                  meets your business needs.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>06</span>
                <h3>Ongoing support</h3>
                <p>
                  Once the solution has been tested and approved, we deploy it
                  to the production environment. We provide post-launch support
                  to ensure that everything is running smoothly and offer
                  training to your team to make sure that you're comfortable
                  with managing your new solution.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tabs-section">
        <div className="container wow fadeInUp">
          <div className="row">
            <div className="col col-6 nav-selector">
              <div className="title-small">
                <span>SERVICES</span>
              </div>
              <ul>
                <li>
                  <a href="#section1">API Development</a>
                </li>
                <li>
                  <a href="#section2">Database Management</a>
                </li>
                <li>
                  <a href="#section3">Cloud Hosting</a>
                </li>
                <li>
                  <a href="#section4">Payment Processing</a>
                </li>
                <li>
                  <a href="#section5">Security and Compliance</a>
                </li>
              </ul>
            </div>
            <div className="col col-6">
              <div className="tab-data" id="section1">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/backend/back-api.webp"
                    alt="Api"
                  />
                </div>
                <h3>API Development</h3>
                <p>
                  Our API development services provide a flexible and scalable
                  platform for building and Mobile app backend development,
                  allowing you to easily connect your applications and services.
                </p>
                <p>
                  We offer full lifecycle API management, from design to
                  deployment and maintenance, and support a wide range of
                  programming languages and frameworks.
                </p>
                <p>
                  We provide a complete range of Backend development services,
                  from building custom Backend layers to enabling cloud
                  integration to help enterprises lead in the digital age.
                </p>
                <p>
                  Slash Star is a top-rated backend development company
                  providing scalable, robust, and high-performing backend
                  services tailored to your project and business requirements.
                </p>
              </div>
              <div className="tab-data" id="section2">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/backend/back-database.webp"
                    alt="Database"
                  />
                </div>
                <h3>Database Management</h3>
                <p>
                  Our database management solution provides reliable and
                  efficient management of your database systems, with robust
                  security and disaster recovery options to keep your data safe.
                  We also offer optimization services to improve performance and
                  reduce costs, as well as data migration services to help you
                  move your data to new systems.
                </p>
              </div>
              <div className="tab-data" id="section3">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/backend/back-cloud.webp"
                    alt="Cloud"
                  />
                </div>
                <h3>Cloud Hosting</h3>
                <p>
                  Our cloud hosting solution provides a highly available and
                  scalable infrastructure for your web applications, with easy
                  deployment and management through our user-friendly console.
                  We offer a range of compute, storage, and networking services,
                  as well as fully managed services such as databases and
                  containers.
                </p>
              </div>
              <div className="tab-data" id="section4">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/backend/payment-proccesing.svg"
                    alt="Branding"
                  />
                </div>
                <h3>Payment Processing</h3>
                <p>
                  Our payment processing solution provides a seamless and secure
                  payment experience for your customers, with support for
                  multiple payment methods and currencies. We offer fraud
                  detection and prevention services, as well as compliance with
                  PCI DSS and other industry standards.
                </p>
                <p>
                  Our payment gateway is easy to integrate with your website or
                  application, and provides real-time reporting and
                  reconciliation.
                </p>
              </div>
              <div className="tab-data" id="section5">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/backend/back-security.webp"
                    alt="Security"
                  />
                </div>
                <h3>Security and Compliance</h3>
                <p>
                  Our security and compliance solution provides comprehensive
                  protection for your applications and data, with 24/7
                  monitoring and proactive threat detection. We also offer
                  compliance services to help you meet industry regulations and
                  standards, such as HIPAA, GDPR and PCI DSS, and provide
                  regular security assessments and penetration testing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="technology-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Technology</span>
          </div>
          <div className="title">
            <h2>
              Empowering Your Business with <br />
              Our <span className="gradient-text">Tech Savvy Stack</span>
            </h2>
          </div>
          <div className="flex-start">
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-java-springboot.svg"
                  alt="Java Springboot"
                />
              </i>
              <span>Java Springboot</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-node.svg" alt="Node" />
              </i>
              <span>Node</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-python.svg" alt="Python" />
              </i>
              <span>Python</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-aws.svg" alt="Aws" />
              </i>
              <span>Amazon Web Service</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-docker.svg" alt="Docker" />
              </i>
              <span>Docker</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-azure.svg" alt="Azure" />
              </i>
              <span>Azure</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-google-cloud.svg"
                  alt="Google Cloud"
                />
              </i>
              <span>Google Cloud</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-firebase.svg"
                  alt="Firebase"
                />
              </i>
              <span>Firebase</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-terraform.svg"
                  alt="Terraform"
                />
              </i>
              <span>Terraform</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-laravel.svg" alt="Laravel" />
              </i>
              <span>Laravel</span>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Why Us</span>
          </div>
          <div className="title">
            <h2>
              The Benefits of <span className="gradient-text">Partnering</span>{" "}
              with Us
            </h2>
          </div>
          {/* Desktop */}
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>Proven Expertise</h3>
                <p>
                  Our seasoned backend developers deliver exceptional results
                  through their extensive experience and industry-specific
                  knowledge.
                </p>
              </div>
              <div>
                <h3>Agile Development Process</h3>
                <p>
                  Our flexible and adaptable approach ensures seamless
                  collaboration and efficient project execution, meeting your
                  unique requirements.
                </p>
              </div>
              <div>
                <h3>Tailored Solutions</h3>
                <p>
                  We create customized backend solutions that perfectly align
                  with your business objectives and enhance your overall
                  operational efficiency.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Modern technologies</h3>
                <p>
                  Our proficiency in the latest technology stacks ensures
                  cutting-edge and future-ready solutions for your backend
                  development needs.
                </p>
              </div>
              <div>
                <h3>High security</h3>
                <p>
                  We prioritize the protection of your data and systems by
                  incorporating advanced security measures and best practices in
                  our backend solutions.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>Robust security</h3>
                <p>
                  We ensure compliance with leading security standards,
                  including NIST CSF, ISO 27001, HIPAA, and GDPR, to keep your
                  data and your users' data safe and secure.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>Proven Expertise</h3>
              <p>
                Our seasoned backend developers deliver exceptional results
                through their extensive experience and industry-specific
                knowledge.
              </p>
            </div>
            <div>
              <h3>Agile Development Process</h3>
              <p>
                Our flexible and adaptable approach ensures seamless
                collaboration and efficient project execution, meeting your
                unique requirements.
              </p>
            </div>
            <div>
              <h3>Tailored Solutions</h3>
              <p>
                We create customized backend solutions that perfectly align with
                your business objectives and enhance your overall operational
                efficiency.
              </p>
            </div>
            <div>
              <h3>Modern technologies</h3>
              <p>
                Our proficiency in the latest technology stacks ensures
                cutting-edge and future-ready solutions for your backend
                development needs.
              </p>
            </div>
            <div>
              <h3>High security</h3>
              <p>
                We prioritize the protection of your data and systems by
                incorporating advanced security measures and best practices in
                our backend solutions.
              </p>
            </div>
            <div>
              <h3>Robust security</h3>
              <p>
                We ensure compliance with leading security standards, including
                NIST CSF, ISO 27001, HIPAA, and GDPR, to keep your data and your
                users' data safe and secure.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-3" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-4" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-5" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BackendDevelopment;
